import React from 'react';
import { api } from '@portal/arq-portal-core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    linea: {
        padding: theme.spacing(1)
    },  
    detalle: {
        backgroundColor: '#fff'
    },
    comTime: {
        color: '#b1b2b2',
        fontSize: '12px',
        marginBottom: '10px'
    },
    comActions: {
        width: '60px',
        alignItems: 'center',
        flexDirection: 'row',
        display: 'flex',
        [`& i`]: {
            fontSize: '24px', 
        },
        [`& .is-liked`]: {
            color: '#DC0028'
        },
        [`& .icon-pro-like`]: {
            cursor: 'pointer'
        },
        [`& span`]: {
            fontSize: '14px'
        }
    },
    detalleComment: {
        backgroundColor: '#f4f4f4',
        padding: '12px 12px 12px 0',
        marginBottom: '12px',
    },
    user: {
        fontWeight: 'bold', 
        color: '#606060',
        fontSize: '16px',
        marginBottom: '10px'
    },
    place: {
        color: '#b1b2b2',
        fontSize: '14px',
        marginBottom: '15px'
    },
    comment: {
        marginBottom: '10px',
        fontSize: '14px',
        color: '#606060',
        wordWrap: 'break-word'
    },
    likeDiv: {
        display: 'flex',
        alignItems: 'center'
    },
    userPic: {
        width: '90px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        float: 'left',
        [`& img`]: {
            width: '50px',
            height: 'auto',
            display: 'block',
            maxWidth: '100%'
        },
        [`& .icon-estrella`]: {
            fontSize: '17px',
            color: '#606060',
            marginRight: '5px',
            '&:last-child': {
                marginRight: '0'
            }
        },
    },
    profileImgWrapper: {
        width:'50px',
        maxHeight: '50px',
        overflow: 'hidden',
        borderRadius: '50%',
        border: '1px solid #d6d8d8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contStars: {
        display: 'flex', 
        justifyContent: 'center',
        marginTop: '5px',
        [`& .star-filled`]: {
            color: '#dc0028'
        }
    }, 
    comInfo: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 90px)',
    },
    deleteEntry: {
        float: 'right',
        position: 'relative',
        marginLeft: '8px',
        [`& .icon-papelera`]: {
            cursor: 'pointer',
            fontSize: '30px'
        },
    },
}));

export function ComentarioCompleto(props: any): JSX.Element {
    
    const likeComment = () => {

        let jsonLike = {
            ContentId: elemento.WallCommentId,
        };
        api.post('/be/piupointcreatelikewallcomment/', {"Entrada": {"json": JSON.stringify(jsonLike)}}).then(()=>{
            canLike?setNlikes(nLikes + 1): setNlikes(nLikes - 1);
            setCanLike(!canLike);
        });
    };

    const classes = useStyles();
    const { elemento, deletecomment } = props;
    const [canLike, setCanLike] = React.useState(elemento?.CanLike);
    const [nLikes, setNlikes] = React.useState(elemento?.Likes? elemento.Likes.length:0);

    const server = api.getApiServer();
    const getProfileImageUrl = (userCode:string) => `${server}/UserImage/${userCode}/`;
    let userLog = elemento?.User.UserLogin.split("\\");
    const userImg = getProfileImageUrl(userLog[userLog.length - 1]);

    React.useEffect(()=>{
        setCanLike(elemento?.CanLike);
        setNlikes(elemento?.Likes? elemento.Likes.length:0)
    },[elemento])

    const getTimeDiff = (CreationDate: string) => {

        let today = new Date();
        let created = new Date(CreationDate + 'Z');
        let hours = 0;
        let minutes = 0;
        let days = 0;
        let month = 0;
        let years = 0;

        const timeDiff = today.getTime() - created.getTime();
        minutes = Math.floor(timeDiff / (1000 * 60));
        hours = Math.floor(timeDiff / (1000 * 60 * 60));
        days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        month = (today.getMonth() + 1) - (created.getMonth() + 1) + (12 * (today.getFullYear() - created.getFullYear()));
        years = today.getFullYear() - created.getFullYear();

        if (minutes < 60) {
            return ` ${minutes === 1 ? 'un' : `${minutes}`} minuto${minutes === 1 ? '' : 's'}`;
        } else if (hours < 24) {
            return ` ${hours === 1 ? 'una' : `${hours}`} hora${hours === 1 ? '' : 's'}`;
        } else if (days < 30) {
            return ` ${days === 1 ? 'un' : `${days}`} día${days === 1 ? '' : 's'}`;
        } else if (month < 12) {
            return ` ${month === 1 ? 'un' : `${month}`} mes${month === 1 ? '' : 'es'}`;
        } else {
            return ` ${years === 1 ? 'un' : `${years}`} año${years === 1 ? '' : 's'}`;
        }
    }
    
    return (
        <div className={classes.detalle}> 
            <div className={classes.detalleComment}>
                <div className={classes.userPic}>
                    <div className={classes.profileImgWrapper}>
                        <img src={userImg}></img>
                    </div>
                    <div className={classes.contStars}>
                        <i className={`icon-estrella ${elemento?.User.Score > 0 ? `star-filled` : ``}`}></i>
                        <i className={`icon-estrella ${elemento?.User.Score > 1 ? `star-filled` : ``}`}></i>
                        <i className={`icon-estrella ${elemento?.User.Score > 2 ? `star-filled` : ``}`}></i>
                    </div>                
                </div>
                <div className={classes.comInfo}>
                    <div className={classes.user}>{elemento?.User?.UserName}</div>
                    <div className={classes.place}>{elemento?.User?.JobTitle}</div>
                    <div className={classes.comment}>{elemento?.ShortBody}</div>
                    <div className={classes.comTime}>hace 
                        {getTimeDiff(elemento?.CreationDate)}
                    </div>
                    <div className={classes.comActions}>
                        <i onClick={likeComment} className={`icon-pro-like ${!canLike ? `is-liked` : ``}`}></i>
                        <span className="inline">({nLikes})</span>
                        <div className={classes.deleteEntry}>{elemento?.CanDelete && <i className="icon-papelera" onClick={() => deletecomment(elemento.WallCommentId)}></i>}</div>
                    </div>
                </div>

            </div>
        </div>
    )
}